import React from "react";
import useOrder from "@Hooks/useOrder";
import Link from "../src/components/Link";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { Box, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import useAuthorization from "@Hooks/useAuth";
import PageHeading from "@Components/PageHeading";
import { useTotals } from "@Hooks/useTotals";
import SiteLayout from "@Components/layouts/SiteLayout";

const CartItemList = dynamic(() => import("src/components/cart/CartItemList"));
const CartTotals = dynamic(() => import("src/components/cart/CartTotals"));

const useStyles = makeStyles(theme => ({
  main: {
    margin: theme.spacing(3, 0),
    minHeight: 300,
  },
  buttonRow: {
    marginTop: theme.spacing(3),
    width: "100%",
    display: "flex",
    flex: "1 100%",
    justifyContent: "space-between",
  },
}));

// export const getServerSideProps = withAuthServerSideProps();

const CartPage = () => {
  const classes = useStyles();
  const { items, remove, getItemRequirements } = useOrder();
  const { push } = useRouter();
  const noItems = items.length === 0;
  const { client } = useAuthorization({ register: true });
  const request = React.useMemo(
    () => ({
      clientId: client ? +client.Id : undefined,
      products: items,
      // ProductIds: items.map(v => +v.Id),
      facilityCount: 0,
    }),
    [client, items],
  );
  const { totals, fetching } = useTotals(request);

  return (
    <SiteLayout>
      <PageHeading text="Cart"></PageHeading>
      <div className={classes.main}>
        {noItems ? (
          <>
            <Typography variant="h6" gutterBottom>
              There are no Items in your cart
            </Typography>

            <Typography paragraph>
              Check out our{" "}
              <Link color="secondary" href="services">
                Services Page
              </Link>{" "}
              and add some services to your cart!
            </Typography>
          </>
        ) : (
          <CartItemList
            items={items}
            removeItem={remove}
            getRequirements={getItemRequirements}
          />
        )}
      </div>
      <Box
        display="flex"
        flexBasis="100%"
        width="100%"
        justifyContent="flex-end"
      >
        <Box flex="0" flexBasis="20%">
          <CartTotals totals={totals} fetching={fetching} />
        </Box>
      </Box>

      <div className={classes.buttonRow}>
        <Button
          onClick={() => push("/services")}
          variant="contained"
          color="secondary"
        >
          Back to Services
        </Button>
        <Button
          onClick={() => push("/checkout")}
          disabled={noItems}
          variant="contained"
          color="primary"
        >
          Proceed to Checkout
        </Button>
      </div>
    </SiteLayout>
  );
};

export default CartPage;
